import React from 'react'

export const LikeIcon = () => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M10.6666 26V14L20.6666 4C20.6666 4 22.6666 4 22 8C21.3333 12 20 13.3333 20 13.3333H25.4055C26.7169 13.3333 27.6734 14.5741 27.3397 15.8423L25.2552 23.7635C24.9084 25.0814 23.7168 26 22.354 26H10.6666Z"
			fill="#4A4A4A"
		/>
		<path d="M2.66663 14H10.6666V28.6667C6.24835 28.6667 2.66663 25.0849 2.66663 20.6667V14Z" fill="#D9D9D9" />
		<path
			d="M2.66663 14H10.6666V28.6667C6.24835 28.6667 2.66663 25.0849 2.66663 20.6667V14Z"
			fill="url(#paint0_linear_28846_34247)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_28846_34247"
				x1="2.26663"
				y1="29.4815"
				x2="2.26663"
				y2="13.1852"
				gradientUnits="userSpaceOnUse">
				<stop stopColor="#5C90FC" />
				<stop offset="1" stopColor="#B7D2FF" />
			</linearGradient>
		</defs>
	</svg>
)
